/* eslint-disable import/no-anonymous-default-export */
export default {
  // colorPrimary: "#004098",
  // colorPrimary: "#1D88D8",
  colorPrimary: "#156EE4",
};
